module.exports = __webpack_public_path__ + "static/img/honor-swiper-4.9607259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honor-swiper-4.png
// module id = Q+8R
// module chunks = 1